import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkConfig } from "@src/store/createAsyncThunk";
import { updateDashboardFilter } from "@src/store/slices/dashboardFilters";
import {
  closeProductPicker,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";

export const saveSelectedAnalyticsProducts = createAsyncThunk<
  void,
  void,
  ThunkConfig
>(
  "productPicker/saveSelectedAnalyticsProducts",
  (_, { getState, dispatch }) => {
    const productPickerData = getProductPickerSelectedProducts(getState());

    void dispatch(
      updateDashboardFilter({
        key: "selectedAnalyticsProducts",
        value: productPickerData.map((p) => {
          return {
            title: p.title,
            id: p.id,
            handle: p.handle,
          };
        }),
      })
    );

    dispatch(closeProductPicker());
  }
);
